import React ,{Component} from 'react';
import {Link} from "react-router-dom"
import { Row, Col, BackTop } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux"
import { getCourses } from '../../../../core/actions/courseGet';
import { getStudents } from '../../../../core/actions/allUsers';
import { getPosts } from '../../../../core/actions/postGet';
import moment from "moment"

class Footer extends Component{
	constructor(props) {
		super(props)
		this.state = {
			courses: [],
			students: [],
			blogPost: []
		}
	}

	componentDidMount() {
    const { courses, students, blogPost} = this.state;
    if (!courses.length) {
      this.props.getCourses();
    }
    if (!students.length) {
      this.props.getStudents();
    }
    if (!blogPost.length) {
      this.props.getPosts()
    }
  }

	componentWillReceiveProps(nextProps) {
		const { courses, students, blogPost } = nextProps;
		if (courses.length > 0) {
      this.setState({ courses });
    }
    if (students.length > 0) {
      this.setState({ students });
		}
		if (blogPost.length > 0) {
      this.setState({ blogPost });
    }
	}

  render(){
		const { courses, students, blogPost } = this.state

    return (
      // <footer className="footer">
        
      //   <section className="second-section">
      //   <Link to="/" className="xlogo">
      //       <img src="/img/B 70565_VJ_6 (3).png" alt="" width="50px"/>
      //       <div>Orsity<br /> <span className="copyright">© {moment().format('YYYY')} Orsity inc | All rights Reserved</span></div>
      //     </Link>
      //   <Row gutter={16} >
        
      //   <Col lg={6} md={6} sm={24}>
      //      <div>
      //     <h5>Product</h5>
      //      <p><Link to="/"> Home</Link></p>
      //      <p><Link to="/pricing">Pricing</Link></p>
           
      //      </div>
      //   </Col>
      //   <Col lg={6} md={6} sm={24}>
      //      <div>
      //     <h5>Community</h5>
      //      <p><Link to="/courses"> Courses</Link></p>
      //      <p><a href="https://orsity.tapfiliate.com"> Become an affiliate</a></p>
           
      //      </div>
      //   </Col>
      //   <Col lg={6} md={6} sm={24}>
      //      <div>
      //     <h5>Connect</h5>
      //      <p><Link to="/about"> About</Link></p>
      //      <p><Link to="/contact"> Contact us</Link></p>
          
      //      </div>
      //   </Col>
      //   <Col lg={6} md={6} sm={24}>
      //      {/* <div>
      //      <Search
      //             size="large"
      //         placeholder="Search for lessons"
      //         onSearch={value => console.log(value)}
      //         enterButton={<Button type="primary"><Icon type="search" /></Button>}
      //       />
      //      </div> */}
      //   </Col>
      //   </Row>
       
      //   </section>
      //   <div className="bottom">
      //      <p>
      //        <Link to="/terms"> Terms & Condition</Link> 
      //        <Link to="/privacy"> Privacy Policy</Link>
      //        </p>
      //     </div>
      //     <BackTop />
      //   </footer>
        <footer>
				<div className="container">
					<div className="row">
						<div className="col-md-3 col-sm-6">
							<div className="footer-logo">
								<a href="index.html"><img src="/img/logo2.png" alt="Logo"/></a>
								<h3 style={{color:"#fff"}}>Orsity</h3>
                <p>Oristy is a group of working web development professionals and open source contributors that provide you with concise, information dense video courses on the best tools in the industry.</p>
								<ul>
									<li><a href="" className="tran3s"><i className="fa fa-facebook" aria-hidden="true"></i></a></li>
									<li><a href="" className="tran3s"><i className="fa fa-twitter" aria-hidden="true"></i></a></li>
									<li><a href="" className="tran3s"><i className="fa fa-google-plus" aria-hidden="true"></i></a></li>
									<li><a href="" className="tran3s"><i className="fa fa-dribbble" aria-hidden="true"></i></a></li>
								</ul>
							</div>
						</div>
						<div className="col-md-2 col-sm-3 footer-list">
							<h6>Company</h6>
							<ul>
								<li><Link to="/blog" className="tran3s">Blog</Link></li>
								<li><Link to="/privacy" className="tran3s">Privacy Policy</Link></li>
								<li><Link to="/terms" className="tran3s">Terms &amp; Condition</Link></li>
								<li><a href="https://orsity.tapfiliate.com" className="tran3s">Become an Affiliate</a></li>
							</ul>
						</div>
						<div className="col-md-2 col-sm-3 footer-list">
							<h6>Product</h6>
							<ul>
								{/* <li><a href="#" className="tran3s">Education Pack</a></li> */}
								{/* <li><a href="#" className="tran3s">Eucation Starter</a></li> */}
								{/* <li><a href="#" className="tran3s">Features &amp; Skills</a></li> */}
								<li><Link to="/pricing" className="tran3s">Pricing</Link></li>
								<li><Link to="/courses" className="tran3s">Courses</Link></li>
								<li><Link to="/subscriptions" className="tran3s">Get Started</Link></li>
								{/* <li><a href="#" className="tran3s">Sell Your Products</a></li> */}
							</ul>
						</div>
						<div className="col-md-2 col-sm-6 footer-list">
							<h6>About us</h6>
							<ul>
								<li><Link to="/about" className="tran3s">About us</Link></li>
								<li><Link to="/contact" className="tran3s">Contact</Link></li>
								{/* <li><a href="#" className="tran3s">Press Releases</a></li> */}
								{/* <li><a href="#" className="tran3s">Jobs</a></li> */}
								{/* <li><a href="#" className="tran3s">Feedback</a></li> */}
							</ul>
						</div>
						<div className="col-md-3 col-sm-6 col-xs-12 footer-subscribe">
							<h6>Subscribe Us</h6>
							<p>Build skills with courses online from world-class universities and companies</p>
							<form action="#">
								<input type="text" placeholder="Your Email"/>
								<button className="tran3s p-bg-color"><i className="flaticon-envelope-back-view-outline"></i></button>
							</form>
						</div>
					</div> 
				</div> 

				<div className="bottom-footer">
					<div className="container">
						<ul className="float-right">
							<li><h3><span className="counter p-color">{courses.length}</span> Courses</h3></li>
							<li><h3><span className="counter p-color">{students.length}</span> Students</h3></li>
							<li><h3><span className="counter p-color">{blogPost.length}</span> Recent news</h3></li>
						</ul>
						<p className="float-left">&copy; 2019 <a href="/" className="tran3s p-color">Orsity</a>. All rights reserved</p>		
					</div>
				</div> 
			</footer>
    )
  }


}

const mapDispatchToProps = dispatch => bindActionCreators({
  getCourses,
  getStudents,
  getPosts
}, dispatch);

const mapStateToProps = state => ({
  courses: state.getCourses.courses,
  blogPost: state.allPosts.posts,
  students: state.allUsers.students,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Footer);